import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'
import { getCollapsedState, setCollapsedState } from '@app/javascript/classes/collapsibleCard'
import { flashNotice } from '@app/javascript/classes/flashMessages'

import I18n from '@app/javascript/i18n/index.js.erb'

export class Controller extends BaseController {
  static targets = ['form', 'icon', 'header', 'dropdown', 'inputContainer', 'message']
  static classes = ['hidden']
  static values = {
    path: String,
    cardTitle: String,
    displayType: String,
    checkedItemsCount: String
  }

  connect() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('h-transform-rotate-180', this.collapsed)
    }
    $(this.inputContainerTarget).find('.c-select-multiple__input-wrapper').hide()

    this.dropdownTarget.classList.toggle(this.hiddenClass, !!this.collapsed)

    addEventListener('select-multiple-component:fetchItems-completed', (event) => {
      this.itemsFetched = true
      $(this.inputContainerTarget).find('.organism-pill-list ol li button').hide()

      $(this.inputContainerTarget).find('.organism-pill-list ol li > div').addClass('rounded-r-pill pr-3')
    })

    if (parseInt(this.checkedItemsCountValue) === 0) {
      this.messageTarget.innerHTML = I18n.t('template.issues.no_issues', { display_type: this.displayTypeValue })
    }
  }

  refreshPills(e) {
    if (e.detail.pillRemovableParent.includes('issues')) {
      this.submitForm()
      this.updateCount()
    }
  }

  toggleEdit() {
    jQuery.fx.off = true
    if (this.hasIconTarget) {
      this.iconTarget.classList.add('h-transform-rotate-180')
    }
    if ($(this.inputContainerTarget).find('.c-select-multiple__input-wrapper').is(':visible')) {
      $(this.inputContainerTarget).find('.c-select-multiple__input-wrapper').hide()
      $(this.inputContainerTarget).find('.organism-pill-list ol li button').hide()
      $(this.inputContainerTarget).find('.organism-pill-list ol li > div').addClass('rounded-r-pill pr-3')
    } else {
      $(this.inputContainerTarget).find('.c-select-multiple__input-wrapper').show()
      this.dropdownTarget.classList.remove(this.hiddenClass)
      $(this.inputContainerTarget).find('.organism-pill-list ol li button').show()
      $(this.inputContainerTarget).find('.organism-pill-list ol li > div').removeClass('rounded-r-pill pr-3')
    }
  }

  toggle() {
    this.collapsed = !this.collapsed

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('h-transform-rotate-180')
    }
    this.dropdownTarget.classList.toggle(this.hiddenClass)
  }

  submitForm() {
    Rails.ajax({
      type: 'POST',
      url: this.pathValue,
      dataType: 'script',
      data: $(this.formTarget).find('input').serialize()
    })
    this.updateCount()
  }

  showNotification() {
    flashNotice('Issue(s) successfully updated.')
  }

  updateCount() {
    const count = $(this.formTarget).find('input:checked').length
    if (count === 0) {
      this.headerTarget.innerHTML = this.cardTitleValue
      this.messageTarget.innerHTML = I18n.t('template.issues.no_issues', { display_type: this.displayTypeValue })
    } else {
      this.headerTarget.innerHTML = this.cardTitleValue + ' (' + count + ')'
      this.messageTarget.innerHTML = ''
    }
  }

  get collapsed() {
    return getCollapsedState(this.cardTitleValue)
  }

  set collapsed(value) {
    return setCollapsedState(this.cardTitleValue, value)
  }
}
